// カメラ部分の内部エラー
export const enum CameraChildErrorCode {
  /** 手動撮影の撮影期限切れ */
  ShootTimeout = 'shoot_timeout',

  /** 自動撮影の撮影期限切れ */
  AutodetectTimeout = 'autodetect_timeout',

  /** 自動判定によるエラー */
  Automatic = 'error_automatic',

  /** 多すぎるエラー */
  ManyRetry = 'many_retry'
}
